<template>
	<v-dialog v-model="visible" width="500" persistent>
		<v-card>
			<v-card-title class="headline text-left">{{ title }}</v-card-title>
			<v-card-text color="red" class="text-left">{{ description }}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<!-- cancel btn -->
				<v-btn color="primary" text @click="deleteEntry(false)">
                    Cancel
                </v-btn>
				<!-- Delete btn -->
				<v-btn color="red darken-1" class="font-weight-bold" text @click="deleteEntry(true)">
                    Delete
                </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "DeleteEntryDialog",
		props: ["visible", "title", "description"],
		methods: {
                // emit to parent and let them know that delete was agreed (true) or disagreed (false)
                deleteEntry(confirm) {
                    this.$emit("deleteEntry", confirm);
			},
		},
	};
</script>

<style lang="css">
	.headline {
		white-space: pre-wrap;
		word-break: break-word;
		text-align: left;
	}
</style>
